import { ApiView } from '@e3dc-react/shell/Elements/ApiView'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { useTypedSelector } from 'src/State/RootReducer'
import { DeviceLinkModel } from 'src/Libs/installations/models'
import { useInstalledSystemsTableData } from '../hooks'

interface UserInstalledInstallationsProps {
  userId: string
}

/**
 * List of all installations installed by a user
 * @param userId
 */
const UserInstalledSystems: React.FC<UserInstalledInstallationsProps> = ({ userId }) => {
  const { t } = useCustomTranslation()
  const currentUserId = useTypedSelector(state => state.auth.userId) ?? 0
  const { columns, fetchProps } = useInstalledSystemsTableData(userId, currentUserId)

  return (
    <Paper title={<Typography variant={'h3'}>{t('service-dashboard.users.installed-installations.title')}</Typography>}>
      <Box>
        <ApiView<DeviceLinkModel>
          fetchProps={fetchProps}
          tableColumns={columns}
          isMobilePaginator={true}
          hasColoredTableColumns
          bodyElevation={0}
          footerElevation={0}
          headerElevation={0}
          listElevation={0}
          noData={t('service-dashboard.users.installed-installations.title.table.no-data')}
        />
      </Box>
    </Paper>
  )
}

export default UserInstalledSystems
